import {
  TableCell,
  TableHeaderCell,
  TableRow,
} from '@unified-checkout/design-system';

type RefundTableProps = {
  refunds: {
    refund_amount: string;
    refunded_on: string;
    refund_transaction_id: number;
  }[];
  total_refund: string;
};

const AmountCell = ({ amount }: { amount?: string }) => (
  <TableCell
    type="custom"
    customContent={
      <span className="text-sm font-medium text-gray-900">{amount}</span>
    }
  />
);

export const RefundTable = ({ refunds, total_refund }: RefundTableProps) => {
  const headerNames = ['Refund', 'Amount', 'Refund txn. ID', 'Refund on'];
  return (
    <table className="w-full">
      <TableRow>
        {headerNames.map((name) => (
          <TableHeaderCell text={name} />
        ))}
      </TableRow>
      <tbody>
        {refunds.map((refund, index) => {
          const { refund_amount, refunded_on, refund_transaction_id } = refund;
          return (
            <TableRow>
              <TableCell type="text" text={`Refund ${index + 1}`} />
              <AmountCell amount={refund_amount} />
              <TableCell type="text" text={refund_transaction_id.toString()} />
              <TableCell type="text" text={refunded_on} />
            </TableRow>
          );
        })}
      </tbody>
      <tfoot>
        <TableRow>
          <TableCell type="text" text="Total Refund" />
          <AmountCell amount={total_refund} />
        </TableRow>
      </tfoot>
    </table>
  );
};
